import RestService from "@/app/services/RestService.js";

export default class AppUtil {

    getBaseUrl() {
        // Using import.meta.env for Vite or process.env.NODE_ENV for webpack
        return import.meta.env?.DEV || process.env.NODE_ENV === 'development' 
            ? 'http://localhost:3000' 
            : 'https://www.nimbleai.co'
    }

    loadUser() {
        const service = new RestService('users')
        let url = '/api/v1/users/current'
        service.executeGet(url).then((response) => {
            nimbleai.model.user = response
        }).catch((message) => {
            console.log('error loading current user')
            console.log(message)
        })
    }

    static parseError(error) {
        const errorMessages = Object.entries(error).map(([field, messages]) => {
            // Capitalize the field name and join multiple messages
            const capitalizedField = field.charAt(0).toUpperCase() + field.slice(1);
            return `${capitalizedField} ${Array.isArray(messages) ? messages.join(', ') : messages}`;
          });
        
        return errorMessages
    }

    /**
     * Checks if the current request is from a white label domain
     * @returns {boolean} True if the request is from a white label domain
     */
    static isWhiteLabelDomain() {
        const currentUrl = window.location.href;
        
        // Check for nimbleabs.co domains (production)
        if (currentUrl.indexOf('nimbleabs.co') !== -1) {
            return true;
        }
        
        // Check for localhost:3001 (development)
        if (currentUrl.indexOf('localhost:3001') !== -1) {
            return true;
        }
        
        return false;
    }
}